import { render, staticRenderFns } from "./CampaignSlots.vue?vue&type=template&id=f93c9b9c&"
import script from "./CampaignSlots.vue?vue&type=script&lang=js&"
export * from "./CampaignSlots.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSlots.vue?vue&type=style&index=0&id=f93c9b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports